













































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import QualificationDto from '@/models/Qualifications/QualificationDto';
import UpdateQualificationRequest from '@/models/Qualifications/UpdateQualificationRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'QualificationEdit'
})
export default class extends GiganautVueDialog {
 
  public entity = new QualificationDto

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(AgencySettingsModule.currentQualification));
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
        if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateQualificationRequest()
    request.updatedAt = this.entity.updatedAt;
    request.name = this.entity.name;
    await AgencySettingsModule.editQualification(request)
    this.dialog = false;
  }
}
